export const iconFontAwesomeMediaplaybackVolumeOff = (
	<i className="fa-solid fa-volume-off"></i>
);
